/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "semantic-ui-css/semantic.min.css"
import { navigate } from "gatsby"

// 存在しないページへのアクセスをキャッチしてホームページにリダイレクト
export const onRouteUpdate = ({ location, prevLocation }) => {
  // 現在のパスが / でない場合はホームページにリダイレクト
  if (location.pathname !== '/' && location.pathname !== '/404/') {
    navigate('/', { replace: true })
  }
}
